import '../utils/pager';

// 通过全局变量获取分页信息
var pageMeta = window.pageMeta;

$('#pager').pager({
  menu: {
    pageSize: true
  },
  page: getQueryString('page') || 1,
  total: pageMeta.total,
  limit: getQueryString('limit') || 5,
  onPaging(page, limit) {
    window.location.search = `?page=${page}&limit=${limit}`;
  }
});

// 获取 url 参数
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) return window.decodeURI(r[2]);
  return null;
}



// WEBPACK FOOTER //
// ./src/js/news.js